import { render, staticRenderFns } from "./complaintInfo.vue?vue&type=template&id=452fd7ae&scoped=true&"
import script from "./complaintInfo.vue?vue&type=script&lang=js&"
export * from "./complaintInfo.vue?vue&type=script&lang=js&"
import style0 from "./complaintInfo.vue?vue&type=style&index=0&id=452fd7ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452fd7ae",
  null
  
)

export default component.exports